import React, { useState } from 'react'
import { AddTransacts } from './AddTransacts'
import { TransactionsTable } from './TransactionsTable'
import AppShell from '../../../Components/AppShell'
import PageHeader from '../../../Components/PageHeader'

const WarehouseRefunds = () => {
  const [isAltered, setIsAltered] = useState(false)

  const handleAlterState = () => {
    setIsAltered((prevstate) => !prevstate)
  }

  return (
    <AppShell>
      <PageHeader
        kicker="Warehouse"
        title="Warehouse audits"
        subtitle="Track refund batches and open refund actions."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Warehouse', to: '/warehouse-tools' },
          { label: 'Refunds' },
        ]}
        actions={<AddTransacts onAlterState={handleAlterState} />}
        status={<span className="nx-chip-info">Transactions</span>}
      />
      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <TransactionsTable isAltereds={isAltered} />
      </div>
    </AppShell>
  )
}

export default WarehouseRefunds
